import { Authentication, BasePostRequest } from './';
import * as t from 'io-ts';

export class AddAccountLinkRequest extends BasePostRequest<undefined> {
    constructor(public emailAddress: string) {
        super(`account-links/${encodeURIComponent(emailAddress)}/`, {}, null, t.undefined, Authentication.Login);
    }
}
